"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AstraCaBCustomerAPI = void 0;
const net = require("@ivanlog/net");
const Auth_1 = require("./classes/Auth");
const Files_1 = require("./classes/Files");
const Geo_1 = require("./classes/Geo");
const HotMessages_1 = require("./classes/HotMessages");
const Lib_1 = require("./classes/Lib");
const Notifications_1 = require("./classes/Notifications");
const Orders_1 = require("./classes/Orders");
const Payments_1 = require("./classes/Payments");
const Profile_1 = require("./classes/Profile");
class AstraCaBCustomerAPI {
    /**
    * @param {string} url baseUrl for api
    * @param {(e: unknown, args?: unknown) => void} errorsHandler? errors handler for safe methods
    */
    constructor(url, errorsHandler) {
        this._httpClient = new net.HTTPClient(url);
        this.auth = new Auth_1.Auth(this._httpClient, errorsHandler);
        this.files = new Files_1.Files(this._httpClient, errorsHandler);
        this.geo = new Geo_1.Geo(this._httpClient, errorsHandler);
        this.hotMessages = new HotMessages_1.HotMessages(this._httpClient, errorsHandler);
        this.lib = new Lib_1.Lib(this._httpClient, errorsHandler);
        this.notifications = new Notifications_1.Notifications(this._httpClient, errorsHandler);
        this.orders = new Orders_1.Orders(this._httpClient, errorsHandler);
        this.payments = new Payments_1.Payments(this._httpClient, errorsHandler);
        this.profile = new Profile_1.Profile(this._httpClient, errorsHandler);
    }
    getHTTPClient() {
        return this._httpClient;
    }
}
exports.AstraCaBCustomerAPI = AstraCaBCustomerAPI;
//# sourceMappingURL=AstraCaBCustomerAPI.js.map